import { Table, TableContainer, Tbody, Th, Thead, Tr } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import { useQuery } from 'react-query'
import { AcompanhamentoItem } from './AcompanhamentoItem'
import { format } from 'date-fns'
import { api } from '../../../services/api'
import { Loader } from '../../../components/ComponentLoader/Loader'

async function getListDiscount() {
  const response = await api.post(`/site/v2/pedido/lista-pendencias-desconto`)

  return response.data.map((item) => {
    return {
      data: item.data_solicitacao
        ? format(new Date(item?.data_solicitacao), 'dd/MM/yyyy HH:mm')
        : '',
      funcionario: item?.nome_usuario_desconto?.toLowerCase(),
      codigo_produto: item?.codigo_produto,
      produto: item?.descricao_produto?.toLowerCase(),
      quantidade: item?.pecas_danificadas,
      observacao: item?.observacao
        ? item?.observacao?.substring(0, 10).concat('...')
        : '',
      originalObservacao: item?.observacao,
      id_usuario: item?.id,
      numero_pedido: item?.ad_numinno
    }
  })
}

export function DescontosPendentes() {
  const initialDateMonth = new Date()
  initialDateMonth.setDate(1)
  const finalDateMonth = new Date()
  finalDateMonth.setDate(30)

  const { data, isLoading } = useQuery({
    queryKey: ['listDiscount'],
    queryFn: async () => getListDiscount(),
  })

  return (
    <>
      <HeadingPages name="Descontos Pendentes" />
      {isLoading && <Loader />}

      <Layout>
        <TableContainer
          w="full"
          mt="1rem"
          size="sm"
          maxH={window.innerHeight - 300}
          overflowY="scroll"
          boxShadow="md"
          borderRadius="md"
          border="1px solid #e2e8f0"
        >
          <Table variant="simple">
            <Thead position="sticky" top="0" bg="#E2E8F0" zIndex={10}>
              <Tr>
                <Th>Data</Th>
                <Th>Nº Pedido</Th>
                <Th>Funcionário</Th>
                <Th>Produto</Th>
                <Th textAlign="center">Quantidade</Th>
                <Th textAlign="center">Motivo</Th>
                <Th textAlign="center">Confirmar</Th>
                <Th />
              </Tr>
            </Thead>
            <Tbody>
              {data?.map((item, index) => (
                <AcompanhamentoItem key={index} item={item} />
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Layout>
    </>
  )
}
